import { Module } from 'vuex';
import { NodeAccountState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: NodeAccountState = {
    nodeAndAccounts: undefined,
    nodeAndAccountCount: 0,
    nodeGroupIds: undefined,
    nodeRandomizableAccounts: undefined,
    nodeRandomizableAccountCount: 0,
    nodeRandomizableAccountType: undefined,
    nodeAccountReservableForWork: undefined,
    index: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    randomizableAccount: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    manuallyRandomizePasswordOrSshKey: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    reservableForWork: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
};

const namespaced: boolean = true;

export const nodeAccount: Module<NodeAccountState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
